// LiveFit+: contador de envio gratis mientras se navega.
// - Barra bajo el menu (snippets/lf-fs-headerbar.liquid, fija con el encabezado): cuanto falta y su avance.
// - Pagina de producto: aviso de lo que pasaria al agregar ese producto.
// Se actualiza con el mismo evento que usa el tema al cambiar el carrito.
import { StandardEvents } from '@shopify/events';

const cfg = window.lfFreeShip;

if (cfg && !window.__lfFreeShipBar) {
  window.__lfFreeShipBar = true;
  let total = Number(cfg.cartTotal) || 0;
  let count = Number(cfg.itemCount) || 0;

  const money = (cents) => {
    const amount = cents / 100;
    const text = amount.toLocaleString('es-MX', {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return String(cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, text);
  };

  const ICON_TRUCK =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
  const ICON_CHECK =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  const render = () => {
    const left = cfg.min - total;
    const pct = Math.max(0, Math.min(100, Math.round((total * 100) / cfg.min)));

    for (const bar of document.querySelectorAll('[data-lf-fs-bar]')) {
      const msg = bar.querySelector('[data-lf-fs-bar-msg]');
      const track = bar.querySelector('.lf-fs-bar__track');
      bar.classList.toggle('lf-fs-bar--active', count > 0);
      bar.classList.toggle('lf-fs-bar--done', count > 0 && left <= 0);
      if (msg) {
        if (count === 0) msg.innerHTML = `${ICON_TRUCK}<span><strong>Envío gratis</strong> en pedidos desde ${money(cfg.min)}</span>`;
        else if (left > 0) msg.innerHTML = `<span>Te faltan <strong>${money(left)}</strong> para tu envío gratis</span>`;
        else msg.innerHTML = `${ICON_CHECK}<span>¡Tu pedido ya tiene <strong>envío gratis</strong>!</span>`;
      }
      if (track) {
        track.hidden = count === 0;
        track.firstElementChild.style.width = `${pct}%`;
      }
    }

    for (const el of document.querySelectorAll('[data-lf-fs-pdp]')) {
      const price = Number(el.dataset.price) || 0;
      let html = el.dataset.lfDefault ?? (el.dataset.lfDefault = el.innerHTML);
      if (count > 0 && left <= 0) html = '<strong>Tu pedido ya tiene envío gratis</strong>';
      else if (count > 0 && total + price >= cfg.min) html = 'Agrégalo y tu pedido tendrá <strong>envío gratis</strong>';
      else if (count > 0) html = `Agrégalo y te faltarán <strong>${money(cfg.min - total - price)}</strong> para el envío gratis`;
      else if (price >= cfg.min) html = 'Este producto ya tiene <strong>envío gratis</strong>';
      el.innerHTML = html;
    }
  };

  const refresh = async () => {
    try {
      const res = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      total = cart.total_price;
      count = cart.item_count;
    } catch {
      /* si falla, se queda el ultimo valor conocido */
    }
    render();
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    (event.promise || Promise.resolve()).finally(refresh);
  });
  // Al cambiar de sabor el tema vuelve a dibujar partes de la pagina de producto
  document.addEventListener(StandardEvents.productSelect, (event) => {
    (event.promise || Promise.resolve()).finally(() => setTimeout(render, 50));
  });
  // Volver con el boton "atras" puede mostrar una pagina guardada con otro carrito
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
}
